
// Service d'envoi d'emails via EmailJS
// Documentation: https://www.emailjs.com/docs/sdk/installation/

// Interface pour les données client
interface ClientData {
    name: string;
    phone: string;
    birthDate?: string; // Nouveau champ
    subject: string; // Origine (Chat, Pack 50€, Promo...)
    details?: string; // Infos supplémentaires (Nom du médium, etc.)
}

let isInitialized = false;

const initEmailJS = (publicKey: string) => {
    const w = window as any;
    if (w.emailjs) {
        w.emailjs.init(publicKey);
        isInitialized = true;
    }
};

export const sendClientData = async (data: ClientData): Promise<boolean> => {
    // Vérification du switch ON/OFF global (géré par AdminContext et stocké dans localStorage)
    const isExternalEnabled = localStorage.getItem('admin_external_email_enabled') !== 'false';

    if (!isExternalEnabled) {
        console.log("Envoi d'email externe DÉSACTIVÉ par l'admin. Les données sont enregistrées uniquement dans l'Inbox locale.");
        return true; // On simule un succès pour ne pas bloquer l'interface utilisateur
    }

    // Récupération dynamique des clés depuis le localStorage (définies dans l'Admin)
    const SERVICE_ID = localStorage.getItem('email_service_id') || "service_ctcp5yu";
    const TEMPLATE_ID = localStorage.getItem('email_template_id') || "template_qcacz6n";
    const PUBLIC_KEY = localStorage.getItem('email_public_key') || "SjvLBrF8kVkSCXD35";

    // Si aucune clé n'est configurée, on simule seulement
    if (!PUBLIC_KEY) {
        console.warn("EmailJS : Aucune clé publique configurée.");
        return true;
    }

    try {
        if (!isInitialized) {
            initEmailJS(PUBLIC_KEY);
        }

        const w = window as any;
        if (!w.emailjs) {
            console.error("EmailJS SDK non chargé.");
            return false;
        }

        // Formatage de la date de naissance
        let formattedBirthDate = "Non renseignée";
        if (data.birthDate) {
            const dateObj = new Date(data.birthDate);
            formattedBirthDate = !isNaN(dateObj.getTime()) 
                ? dateObj.toLocaleDateString('fr-FR') 
                : data.birthDate;
        }

        let fullDetails = data.details || "Pas de détails supplémentaires.";
        if (data.birthDate) {
            fullDetails += `\n\nDate de Naissance : ${formattedBirthDate}`;
        }

        const templateParams = {
            to_name: "Administrateur AstroX",
            from_name: data.name,
            name: data.name,
            phone: data.phone,
            subject: data.subject,
            message: fullDetails,
            birth_date: formattedBirthDate,
            
            // Paramètres génériques
            to_email: "seebzakaria@gmail.com", 
            email: "seebzakaria@gmail.com",   
            reply_to: data.name
        };

        const response = await w.emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
        
        if (response.status === 200) {
            console.log("Email externe envoyé avec succès !", response);
            return true;
        }
        return false;

    } catch (error: any) {
        console.error("Erreur lors de l'envoi de l'email :", error);
        return false; // On retourne false en cas d'échec réel, mais l'app peut continuer
    }
};
